import "./SignIn.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginDataService from "../../../Services/LoginService";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import Alert from "../../Controls/Alerts/Alerts";
//import { useCookies } from "react-cookie";

const Launch = (props) => {
  // const [cookies, setUserNameCookie] = useCookies([""]);
  // const [signCookie, settabCookie] = useCookies([""]);
  let KeyVal = "";
  let rpk = "";
  let rft = "";
  const searchParams = new URLSearchParams(document.location.search);
  for (const [key, value] of searchParams) {
    if (key == "Key") KeyVal = value;
  }
  const history = useNavigate();
  // settabCookie("SignIn", "SignIn");
  // let UserName = getCookie("UserName");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSignIn", "Referesh");
  //   }
  // }

  const [openLoader, setOpen] = useState(false);
  localStorage.setItem("header", null);
  localStorage.setItem("UserName", "");
  localStorage.setItem("JWtToken", "");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [timer, setTimer] = useState("");

  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }

  let value = 1;
  useEffect(() => {
    const onPageLoad = () => {
      submitForm();
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);
  async function submitForm() {
    const searchParams = new URLSearchParams(document.location.search)
    if (KeyVal === "") {
      setAlertMsg("Invalid request.");
      setAlertType("warning");
      history("/");
    }
    else {
      setOpen(true);
      var keyRDocsDocumentDetails = {
        key: KeyVal
      };
      var response = await LoginDataService.CacheData(keyRDocsDocumentDetails);
      if (response === "Server maintenance") {
        history("/maintenance");
        return;
      }
      else if (response.data.errorMessage != null) {
        if (
          response.data.errorMessage ==
          "Your account has been blacklisted, please contact the administrator."
        )
          history("/blacklisted");
        else if (
          response.data.errorMessage ==
          "Your account has been suspended, please contact the administrator."
        )
          history("/suspended");
        else if (
          response.data.errorMessage ==
          "No subscription plan is assigned for this account. Please contact your company administrator."
        )
          history("/noplan");
      }
      else if (!response.data.isDraft) {
        localStorage.setItem("language", response.data.language);
        history("/RdocsDataSend");
        return;
      }
      else if (response && response.status === 200) {
        setOpen(false);
        localStorage.setItem("header", "1");
        localStorage.setItem("UserName", response.data.email);
        //setUserNameCookie("UserName", response.data.email);
        localStorage.setItem("DocumentID", response.data.documentId);
        localStorage.setItem("Level", response.data.rdocsLevel);
        //settabCookie("TabSignIn", "Signed");
        localStorage.setItem("language", response.data.language);
        localStorage.setItem("UserRole", response.data.userRole);
        localStorage.setItem("Companyname", response.data.companyName);
        localStorage.setItem("SMSAuthentication", response.data.smsAuthentication)
        history("/send");
      }
      else {
        setOpen(false);
        setAlertMsg("The session has expired. Please log-in again.");
        setAlertType("warning");
        setTimeout(() => {
          history("/");
        }, 2000);

      }
    }

  }
  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      <div className="container-login100">
        {/* alerts */}
        <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg}
          setAlertType={setAlertType}></Alert>
        {/* end */}

        <img
          className="wave"
          src="assets/img/wave_yellow.svg"
          style={{ color: "f2d8da" }}
          alt="Wave"
        />
        <main className="login_wrapper my2">
          <div className="container">
            <div className="text-center mb-2">
              <img src="assets/img/RDocs.png" className="logo" alt="logo" />
            </div>

            {/* <div className="row login-box-12 container-box">
            
            <div className="col-lg-12 col-sm-12">
              <div className="login-inner-form ">
                <div className="details pb-2">
                  <h3 className="font-26">Welcome back!</h3>

                  
                  <div className="form-group input-wrapper">
                    <input
                      type="email"
                      name="email"
                      className="input-text"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span className="fa fa-envelope input-icon text-gray"></span>
                  </div>
                  <div className="form-group input-wrapper">
                    <input
                      type="password"
                      name="email"
                      className="input-text"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className="fa fa-key input-icon text-gray"></span>
                  </div>

                  <div className="checkbox res-flex clearfix d-flex align-items-center justify-content-between">
                    <div
                      className="form-check checkbox-theme justify-content-center ps-1 w-50 res-w100 "
                      style={{ textAlign: "left" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="rememberMe"
                      />
                      <label className="form-check-label" htmlFor="rememberMe">
                        Remember me
                      </label>
                    </div>
                    <div className="form-check checkbox-theme w-50 res-w100">
                      <a href="https://rpost.com/forgot-password" className="forgetlink">
                        Forgot password?
                      </a>
                    </div>
                  </div>

                  <div className="form-group mb-0 d-flex align-items-center justify-content-center">
                    <button
                      className="btn-md btn-theme btn-block mt-2 w-75"
                      style={{
                        boxShadow: "rgb(58 177 109 / 50%) 0px 10px 20px 0px",
                        background: "#3ab16d",
                      }}
                      onClick={submitForm}
                    >
                      Sign in
                    </button>
                  </div>
                  <div className="or_options text-center mb-3">
                    <div className="or_text ">
                      <span style={{ fontSize: "15px" }}>
                        Or
                        <a href="https://app.rmail.com/account" className="ms-1 forgetlink">
                          {" "}
                          Sign up
                        </a>{" "}
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div> */}
          </div>
        </main>
      </div>
    </>
  );
};

export default Launch;
